import { PocIconButton } from 'commons/components/components-wrapper/poc-icon-button.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';
import { TriggerActionsState } from '../constants/frontend-enums';
import { AutomationRulesCardLayout, AutomationRulesPocCard, FlexDiv } from '../styled/automation-rules.style';
import { DeleteOptionParams } from '../types/automation-rules.type';

interface ActionCardProps {
    content: React.ReactNode;
    id: number;
    isDeleteShown: boolean;
    onDeleteOptionHandler: (data: DeleteOptionParams) => () => void;
}

export const ActionCard = React.memo((props: ActionCardProps) => {
    const { content, id, isDeleteShown, onDeleteOptionHandler } = props;

    const { t } = useTranslation();
    return (
        <AutomationRulesPocCard>
            <AutomationRulesCardLayout className="spc-btw alg-itm-ctr" padding="24px">
                <AutomationRulesCardLayout className="alg-itm-ctr" padding="0">
                    <PocTypography variant="subtitle1">
                        {t('settings.system.automation-rules.logical-operators.then')}
                    </PocTypography>
                    {content}
                </AutomationRulesCardLayout>
                <FlexDiv>
                    {isDeleteShown && (
                        <PocIconButton
                            icon="delete"
                            family="filled"
                            onClick={onDeleteOptionHandler({ id, parentArrayName: TriggerActionsState.actions })}
                        />
                    )}
                </FlexDiv>
            </AutomationRulesCardLayout>
        </AutomationRulesPocCard>
    );
});
